import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Paper, Typography } from '@/core/ui';
import { t } from '@/core/localization';
import { Link } from 'react-router-dom';
// TODO: (styling) https://tailwindui.com/components/preview
const NoAccess = ({ customMessage }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h1", sx: { opacity: 0 }, children: "You don't have permission to access the contents of this page." }), _jsx(Paper, { sx: { p: 4 }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '600px',
                        gap: 5,
                    }, children: [_jsx(Box, { children: _jsx(Typography, { variant: "h3", children: customMessage ?? t('you.dont.have.permission.to.access.the.contents.of.this.page') }) }), _jsx(Box, { children: _jsx(Typography, { variant: "h3", children: _jsx(Link, { to: "/", reloadDocument: true, children: t('go.to.the.main.page') }) }) })] }) })] }));
};
export { NoAccess };
